import helper from '../../../helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('funnel');
export const actions = helper.createActions('funnel', actionTypes);
